export default __webpack_public_path__ + "static/media/visibility_off-24px.52336c80.svg";